import type { FC, ReactNode } from 'react';
import styles from './Section.module.css';

interface SectionProps {
  id?: string;
  children: ReactNode;
  tone?: 'default' | 'muted' | 'dark';
  spacing?: 'compact' | 'default' | 'hero';
  /** When true (desktop only), the section pins to the header offset and
   *  participates in the GSAP stacking-cards scroll. Mobile ignores this. */
  sticky?: boolean;
}

export const Section: FC<SectionProps> = ({
  id,
  children,
  tone = 'default',
  spacing = 'default',
  sticky = false,
}) => {
  return (
    <section
      id={id}
      className={[
        styles.root,
        styles[`tone_${tone}`],
        styles[`spacing_${spacing}`],
        sticky ? styles.root_sticky : '',
      ].join(' ')}
    >
      {children}
    </section>
  );
};

Section.displayName = 'Section';
